import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { type UrlShortenerModalStore } from 'pages/settings/pages/urlShortener/store/urlShortenerModalStore'

export type IAddCustomDomainModalActionProps = {
  store: UrlShortenerModalStore
}

export const AddCustomDomainModalAction = observer(
  ({ store }: IAddCustomDomainModalActionProps) => {
    const { closeModal, handleContinue, isContinueBtnDisabled, loading } = store

    return (
      <>
        <Button
          typeBtn={'contained'}
          contained={'secondary'}
          text={'Cancel'}
          onClick={closeModal}
        />

        <Button
          typeBtn={'contained'}
          contained={'primary'}
          text={'Continue'}
          onClick={handleContinue}
          disabled={isContinueBtnDisabled || loading}
          loading={loading}
        />
      </>
    )
  }
)
